// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as UserCuesSlice from "../slice"
import { userCuesServiceClient } from "app/rpc/client"
import { grpc } from "../../../app/rpc/executor"
import { CreateUserCueRequest, UserCue } from "../../../generated/wisetime/user/cues/v4/user_cues_pb"
import { debug } from "app/logging"

type CreateUserCueRpc = (request: CreateUserCueRequest) => Observable<UserCue>

export const createUserCue = (createUserCueRpc: CreateUserCueRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.createUserCue.match),
      mergeMap(({ payload: request }) =>
        of(request)
          .pipe(
            mergeMap(createUserCueRpc),
            map(userCue => userCue.toObject()),
            map(UserCuesSlice.createUserCue),
            catchError(_ => {
              debug("Failed to create user cue")
              return of(Actions.createUserCueFailed)
            })
          )
      )
    )

const createUserCueRpc = (request: CreateUserCueRequest): Observable<UserCue> =>
  grpc(() => userCuesServiceClient.createUserCue(request, null))

export default createUserCue(createUserCueRpc)
